module.exports = {
      id: "icon-website-analytics-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-website-analytics",
      toString: function () {
        return this.url;
      }
    }